import PageContent from "@/components/PageContent";
import PageHeader from "@/components/PageHeader";
import Spinner from "@/components/Spinner";
import { useAuditLogsQuery } from "@/modules/auditLogs/hooks/useAuditLogsQuery";
import { useAuditLogsBreadcrumb } from "@/modules/auditLogs/hooks/useAuditLogsBreadcrumb";
import { AuditLogDiff } from "@/modules/auditLogs/components/AuditLogDiff";
import { AuditLogDetailsSection } from "@/modules/auditLogs/components/AuditLogDetailsSection";
import { AuditLogDetailsHeader } from "@/modules/auditLogs/components/AuditLogDetailsHeader";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { FilterType } from "@/lib/filters/FilterType";
import useQueryData from "@/hooks/useQueryData";

export const AuditLogDetails = () => {
  const params = useParams();
  const id = params.id as string;
  const { t } = useTranslation();
  const { query } = useAuditLogsQuery({
    name: ["auditLogDetail", id].join(":"),
    enabled: !!id,
    filters: [
      {
        id: "id",
        value: {
          value: id,
          filter: FilterType.EqualsString,
        },
      },
    ],
    keepPreviousData: false,
  });
  const auditLog = useQueryData(query)[0];
  const breadcrumbItems = useAuditLogsBreadcrumb(auditLog?.table_name);

  if (query.isPending || query.isLoading) {
    return (
      <>
        <PageHeader breadcrumbItems={breadcrumbItems} />
        <PageContent>
          <Spinner label={t("table.loading")} className="w-full h-full" />
        </PageContent>
      </>
    );
  }

  if (!auditLog) {
    return null;
  }

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <PageContent
        icon={<FileText className="w-6 h-6 mr-3" />}
        title={<AuditLogDetailsHeader auditLog={auditLog} />}
      >
        <div className="py-4">
          <AuditLogDiff auditLog={auditLog} />
          <AuditLogDetailsSection auditLog={auditLog} />
        </div>
      </PageContent>
    </>
  );
};
